import React, {FunctionComponent} from "react";
import {File, FileType} from '../../models/file.model';
import {CONSTANTS} from "../../common/constants";
import "./FilePreview.scss";
import {DocumentPreview} from "./file-previewers/DocumentPreview";
import {PDFPreview} from "./file-previewers/PDFPreview";
import {ImagePreview} from "./file-previewers/ImagePreview";
import {VideoPreview} from "./file-previewers/VideoPreview";
import {OtherFilePreview} from "./file-previewers/OtherFilePreview";

interface FilePreviewProps {
    file: File;
}

export interface FilePreviewerProps {
    file: File;
    fileType: string;
}

export const FilePreview: FunctionComponent<FilePreviewProps> = (props) => {
    const {file} = props;

    const filePreviewers = {
        [CONSTANTS.FILE_TYPES.DOCUMENT]: DocumentPreview,
        [CONSTANTS.FILE_TYPES.PDF]: PDFPreview,
        [CONSTANTS.FILE_TYPES.IMAGE]: ImagePreview,
        [CONSTANTS.FILE_TYPES.VIDEO]: VideoPreview,
        [CONSTANTS.FILE_TYPES.OTHER]: OtherFilePreview,
    };

    const renderFilePreviewer = () => {
        let fileType = new FileType(file).fileType;
        let FilePreviewer = filePreviewers[fileType];

        return <FilePreviewer file={file} fileType={fileType} />
    };

    return file ? (
        <div className="file-previewer">
            {renderFilePreviewer()}
        </div>
    ) : null;
};